export { default as NextIcon } from '~icons/mdi/navigate-next';
